import { getAccessToken } from './auth';

export const FP_API_BASE = 'https://fp-api.focuspointintl.com';

export const DEV2_DEVICE_TEST_TRIGGER_PATH = '/api/dev2/device-test/trigger';
export const DEV2_DEVICE_TEST_SMS_REPLY_PATH = '/api/dev2/device-test/sms-reply';

async function postDev2DeviceTest(path, body) {
  const accessToken = await getAccessToken();
  if (!accessToken) {
    throw new Error('Authentication failed');
  }

  const response = await fetch(`${FP_API_BASE}${path}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(`Request failed (${response.status})`);
  }

  if (response.status === 401) {
    throw new Error(data.message || 'Session expired — sign in again');
  }

  return { httpStatus: response.status, ...data };
}

export function triggerDev2DeviceTest(body, { step } = {}) {
  const payload = step ? { ...body, step } : body;
  return postDev2DeviceTest(DEV2_DEVICE_TEST_TRIGGER_PATH, payload);
}

export function sendDev2DeviceTestSmsReply(body) {
  return postDev2DeviceTest(DEV2_DEVICE_TEST_SMS_REPLY_PATH, body);
}

export function buildDev2TriggerPayload(body, { step } = {}) {
  return step ? { ...body, step } : body;
}
